export enum ContentsDetailType {
  /** 일반 */
  NORMAL = 'NORMAL',
  /** Editors 기획 */
  EDITOR = 'EDITOR',
  /** SNS */
  SNS = 'SNS',
  /** Ads */
  ADS = 'ADS',
  /** 70주년 스토리 */
  STORY = 'STORY',
  /** 보도 자료 */
  REPORT = 'REPORT',
  /** ESG */
  ESG = 'ESG',
  /** 주간 뉴스 */
  WEEK = 'WEEK',
  /** 갓찌 웹툰 - 만화 */
  CARD_COMICS = 'CARD_COMICS',
  /** 신년사 */
  NEWYEAR = 'NEWYEAR',
  /** 추모사 */
  MEMORIAL = 'MEMORIAL',
}
